export default {
  drawer: null,
  color: 'blue darken-2',
  image: '',
  company: 0
}
